var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.725,
    height: 22.921,
    viewBox: "0 0 28.725 22.921",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-549.999 -140)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1810.029 -5117.333)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1255.07,5257.333h-3.058a1.905,1.905,0,0,0-1.9,1.9v3.057a1.905,1.905,0,0,0,1.9,1.9h3.058a1.905,1.905,0,0,0,1.9-1.9v-3.057A1.905,1.905,0,0,0-1255.07,5257.333Zm.5,4.96a.5.5,0,0,1-.5.5h-3.058a.5.5,0,0,1-.5-.5v-3.057a.507.507,0,0,1,.5-.5h3.058a.5.5,0,0,1,.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1255.07,5264.695h-3.058a1.9,1.9,0,0,0-1.9,1.9v3.058a1.9,1.9,0,0,0,1.9,1.9h3.058a1.9,1.9,0,0,0,1.9-1.9V5266.6A1.9,1.9,0,0,0-1255.07,5264.695Zm.5,4.96a.5.5,0,0,1-.5.5h-3.058a.5.5,0,0,1-.5-.5V5266.6a.508.508,0,0,1,.5-.5h3.058a.5.5,0,0,1,.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1255.07,5272.014h-3.058a1.905,1.905,0,0,0-1.9,1.9v3.057a1.9,1.9,0,0,0,1.9,1.9h3.058a1.9,1.9,0,0,0,1.9-1.9v-3.057A1.905,1.905,0,0,0-1255.07,5272.014Zm.5,4.96a.5.5,0,0,1-.5.5h-3.058a.5.5,0,0,1-.5-.5v-3.057a.507.507,0,0,1,.5-.5h3.058a.5.5,0,0,1,.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1250.572,5260.134h13.75a.687.687,0,0,0,.688-.688.687.687,0,0,0-.688-.687h-13.75a.688.688,0,0,0-.687.687A.687.687,0,0,0-1250.572,5260.134Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1250.572,5262.455h6.875a.688.688,0,0,0,.688-.688.687.687,0,0,0-.688-.687h-6.875a.687.687,0,0,0-.687.687A.688.688,0,0,0-1250.572,5262.455Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1250.572,5267.652h13.75a.686.686,0,0,0,.688-.687.687.687,0,0,0-.688-.688h-13.75a.688.688,0,0,0-.687.688A.687.687,0,0,0-1250.572,5267.652Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1250.572,5269.973h6.875a.687.687,0,0,0,.688-.687.687.687,0,0,0-.688-.688h-6.875a.687.687,0,0,0-.687.688A.688.688,0,0,0-1250.572,5269.973Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1243.96,5275.917h-6.875a.688.688,0,0,0-.688.688.688.688,0,0,0,.688.687h6.875a.687.687,0,0,0,.687-.687A.687.687,0,0,0-1243.96,5275.917Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1250.835,5274.972h5.761V5273.6h-5.761a.687.687,0,0,0-.688.687A.688.688,0,0,0-1250.835,5274.972Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1132.729,5188.617a5.606,5.606,0,0,0-5.6,5.6,5.606,5.606,0,0,0,5.6,5.6,5.606,5.606,0,0,0,5.6-5.6A5.606,5.606,0,0,0-1132.729,5188.617Zm0,10a4.406,4.406,0,0,1-4.4-4.4,4.406,4.406,0,0,1,4.4-4.4,4.406,4.406,0,0,1,4.4,4.4A4.406,4.406,0,0,1-1132.729,5198.617Z",
    transform: "translate(1705.854 -5036.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1131.68,5196.058a1.922,1.922,0,0,1-.627.107,1.942,1.942,0,0,1-1.843-1.349h1.2a.6.6,0,0,0,.6-.6.6.6,0,0,0-.6-.6h-1.2a1.958,1.958,0,0,1,2.466-1.242.6.6,0,0,0,.76-.377.6.6,0,0,0-.377-.76,3.147,3.147,0,0,0-1.012-.169,3.15,3.15,0,0,0-3.087,2.548h-.349a.6.6,0,0,0-.6.6.6.6,0,0,0,.6.6h.349a3.151,3.151,0,0,0,3.087,2.548,3.141,3.141,0,0,0,1.014-.169.6.6,0,0,0,.374-.762A.6.6,0,0,0-1131.68,5196.058Z",
    transform: "translate(1705.854 -5036.895)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem);
export default __webpack_public_path__ + "static/media/item.23bd86f0db2db5114539f2caa642c80c.svg";
export { ForwardRef as ReactComponent };